export default __webpack_public_path__ + "static/media/Believer's Gloves of the Soaring God.b311ff28.jpg";